// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__XIXsK","info":"UpdateTermsInfo_info__1tbbD"};